module.exports = __webpack_public_path__ + "static/media/laststep.db648f8c.png";